'use strict';

const _ = require('lodash');
const google = require('../modules/google');

const elements = {
    form: $('.store-locator-form'),
    resultsContainer: $('.store-search-results'),
    loadingIndicator: $('.js-store-locator-locading-indicator'),
    filters: $('.filters'),
    details: $('.store-details'),
    noresult: $('.store-locator-noresult'),
    addressDetails: $('input[id$="_addressDetails"]'),
    countryCode: $('select[id$="_countryCode"]'),
    moreStoresLoader: $('.js-more-stores-loader')
};

let searchPayload = null;

exports.init = function() {
    cleanPayload();

    if (elements.form.length > 0) {
        //Hide activity indicator
        elements.loadingIndicator.removeClass('spinner-visible');

        //Get saved changes
        getSavedChanges();

        //Initialize Google Place AutoComplete Textfield
        google.places.initStoreList(elements.countryCode.val(), triggerReceiveAddressAutoComplete);

        //Disable form submit
        elements.form.on('submit', function(e) {
            e.preventDefault();
            return;
        });

        //Show more button
        $(document).on('click','.show-more-btn', function(e) {
            e.preventDefault();
            const length = $('.store').length;
            searchPayload.nextPageToken = length;
            getStoreList(true);
            elements.moreStoresLoader.addClass('spinner-visible');
        });

        //trigger click function on radio buttons
        $('.js-checkmark').on('keyup', function(e){
            if (e.which == 13) {
                // on enter trigger click function
                $(this).trigger('click');
            }
        });

        //Check country dropdown changes
        elements.countryCode.on('change', function() {
            //Clean the payload
            cleanPayload();

            //Set country code to payload
            searchPayload.checkStoreAvailability = true;
            searchPayload.filterCountryCode = elements.countryCode.val();

            //Save latest changes
            saveChanges();

            //Clear address field
            elements.addressDetails.val('');

            const types = $('input[name$="_storeType"]');
            _.forEach(types, function(object) {
                object.checked = object.classList.contains('normal');
            });

            //Initialize Google Place AutoComplete Textfield
            google.places.initStoreList(elements.countryCode.val(), triggerReceiveAddressAutoComplete);

            //Get Store List (Ajax)
            getStoreList();

        });

        $('input[name$="_storeType"]').on('change', function() {
            searchPayload.storeType = $('input[name$="_storeType"]:checked').val();

            //Reset page
            searchPayload.nextPageToken = 0;

            //Save latest changes
            saveChanges();

            //Get Store List (Ajax)
            getStoreList();
        });

        // Current location
        $('.js-store-list-current-location').on('click', function() {
            // cleanFlyoutStores(); //Clean the flyout
            google.places.getCurrentLocation(tiggerCurrentLocation);
        });

        const searchText = elements.addressDetails.val();
        if (searchText && searchText != '') {
            google.places.searchPlace(searchText, triggerUserAddressSearched);
        } else {
            getStoreList();
        }
    }

    // init embedded google map in details page
    if (elements.details.length > 0) {
        const map = elements.details.find('.store-location').find('.store-map');
        google.maps.init(map);
    }
};


// Local Storage

function saveChanges() {
    const searchText = elements.addressDetails.val();
    const countryCode = elements.countryCode.val();
    const types = getEnabledStoreType();

    if (typeof(Storage) !== 'undefined') {
        const changes = {
            query: searchText,
            countryCode: countryCode,
            types: types
        };
        localStorage.storeLocator = JSON.stringify(changes);
    }
    return;
}

function getSavedChanges() {

    if (typeof(Storage) !== 'undefined' && 'storeLocator' in localStorage) {
        const changes = JSON.parse(localStorage.storeLocator) || {};

        elements.addressDetails.val(changes.query);
        elements.countryCode.val(changes.countryCode);
        searchPayload.filterCountryCode = changes.countryCode;
        _.forEach(changes.types, function(value, key) {
            $('input.' + key + '[name$="_storeType"]').prop('checked', value || false);
        });
        searchPayload.storeType = $('input[name$="_storeType"]:checked').val();
    } else {
        cleanPayload();
    }

    //Get availiability of stores when initializing the page

    searchPayload.checkStoreAvailability = true;
    return;
}

// Google Place API Triggers

/*
    Notifier when AutoComplete Search Textfield is entered
*/
function triggerReceiveAddressAutoComplete() {
    //Check if this is google event
    if (!!this && this !== null) {
        const place = this.getPlace();
        if (place) {
            handleGooglePlaceResults([place]);
            searchPayload.searchText = elements.addressDetails.val();
        }
    } else {
        cleanPayload();
    }

    //Save latest changes
    saveChanges();

    //Get Store List (Ajax)
    getStoreList();
}

/*
    Notifier when search for user's address in addressbook
*/
function triggerUserAddressSearched(results, status) {
    if (status == 'OK' && results && results.count > 0) {
        handleGooglePlaceResults(results);

        //Save latest changes
        saveChanges();

        //Get Store List (Ajax)
        getStoreList();

    }
}

/*
    Notifier when user tap on Current location
*/
function tiggerCurrentLocation(results, latitude, longitude) {
    //Check if location is OK
    if (results && latitude && longitude) {
        handleGooglePlaceResults(results);
        searchPayload.latitude = latitude;
        searchPayload.longitude = longitude;

        //Set Country Code
        if (searchPayload.filterCountryCode) {
            const exists = $('select[id$="_countryCode"] option[value="' + searchPayload.filterCountryCode + '"]').length > 0;
            if (exists) {
                elements.countryCode.val(searchPayload.filterCountryCode);
                elements.addressDetails.val(google.places.getReadableAddress(results));

                //Save latest changes
                saveChanges();

                //Get Store List (Ajax)
                getStoreList();
            }
        }
    }
}

function handleGooglePlaceResults(results) {
    cleanPayload();
    searchPayload.filterCity = getLocationValue('locality', true, results);
    searchPayload.filterPostalCode = getLocationValue('postal_code', true, results);

    if (results && results.length > 0) {
        const result = results[0];
        if (result && result.geometry && result.geometry.location) {
            searchPayload.latitude = result.geometry.location.lat();
            searchPayload.longitude = result.geometry.location.lng();
        }
    }
}

// Helpers

function cleanPayload() {
    let selectedStoreType = $('input[name$="_storeType"]:checked').val();
    if (!selectedStoreType) {
        selectedStoreType = 'normal';
    }
    searchPayload = {
        latitude: '',
        longitude: '',
        countryCode: elements.countryCode.val(),
        filterPostalCode: '',
        filterCity: '',
        filterCountryCode: elements.countryCode.val(),
        searchText: '',
        nextPageToken: 0,
        storeType: selectedStoreType,
        checkStoreAvailability: false
    };
}

function getLocationValue(locationType, isLongName, results) {
    const fallBackAddress = '';
    for (let indexResult = 0; indexResult < results.length; indexResult++) {
        const result = results[indexResult];
        if (result.address_components) {
            for (let indexAddressComponent = 0; indexAddressComponent < result.address_components.length; indexAddressComponent++) {
                const addressComponent = result.address_components[indexAddressComponent];
                if (addressComponent.types.indexOf(locationType) != -1) {
                    return isLongName ? addressComponent.long_name.latinise() : addressComponent.short_name.latinise();
                }
            }
        }
    }
    return fallBackAddress;
}

function getStoreList(skipTypesUpdating) {
    $('.js-load-more-stores').remove();

    const isClearingResult = (searchPayload.nextPageToken == 0);
    showLoadingIndicator(isClearingResult);
    if (isClearingResult) {
        elements.resultsContainer[0].innerHTML = '';
    }
    $.ajax({
        type: 'POST',
        url: Urls.filterStores,
        contentType: 'application/json',
        data: JSON.stringify(searchPayload),
        success: function(htmlData) {
            searchPayload.checkStoreAvailability = false;
            if (htmlData) {
                const data = $($.parseHTML(htmlData));
                const results = data.find('.js-store-item');
                const loadMore = data.find('.js-load-more-stores');
                elements.resultsContainer.append(results);

                if (loadMore.length) {
                    elements.resultsContainer.after(loadMore);
                }

                elements.moreStoresLoader.removeClass('spinner-visible');

                if (!skipTypesUpdating){
                    const selectedStoreType = data.find('input[name="SelectedStoreType"]').val();
                    const availableStoreTypes = data.find('input[name="AvailableStoreTypes"]').val();
                    if (selectedStoreType || availableStoreTypes) {

                        const storeType = $('input[name$="_storeType"]');
                        storeType.each(function(index, object) {

                            if (selectedStoreType) {
                                object.checked = $(object).hasClass(selectedStoreType);
                            }

                            if (availableStoreTypes) {
                                const availableStoreTypesJson = JSON.parse(availableStoreTypes);
                                const row = $(object).closest('.form-row').show();
                                let rowVisible = false;

                                if ($(object).hasClass('normal')) {
                                    rowVisible = availableStoreTypesJson.rgcStoreExist;
                                } else if ($(object).hasClass('city-spa')) {
                                    rowVisible = availableStoreTypesJson.urbanStoreExist;
                                } else if ($(object).hasClass('shop-in-shop')) {
                                    rowVisible = availableStoreTypesJson.deptStoreExist;
                                }

                                if (rowVisible) {
                                    row.show();
                                } else {
                                    row.hide();
                                }
                            }
                        });
                        searchPayload.storeType = $('input[name$="_storeType"]:checked').val();
                    }
                }

                results.first().find('a').first().focus();
            }

            const length = $('.store').length;
            hideLoadingIndicator(length);
        }
    });
}

function getEnabledStoreType() {
    const storeTypes = $('input[name$="_storeType"]:checked');
    const types = {
        'normal': false,
        'city-spa': false,
        'shop-in-shop': false
    };

    storeTypes.each(function(index, object) {
        if ($(object).hasClass('normal')) {
            types['normal'] = true;
        } else if ($(object).hasClass('city-spa')) {
            types['city-spa'] = true;
        } else if ($(object).hasClass('shop-in-shop')) {
            types['shop-in-shop'] = true;
        }
    });

    return types;
}

// Extra Methods

function hideLoadingIndicator(count) {
    elements.loadingIndicator.removeClass('spinner-visible');
    if (count > 0) {
        elements.resultsContainer.css('display', 'inline-block');
    } else {
        elements.noresult.css('display', 'inline-block');
    }
}

function showLoadingIndicator(hideResult) {
    elements.loadingIndicator.addClass('spinner-visible');
    if (hideResult) {
        elements.noresult.hide();
        elements.resultsContainer.hide();
    }
}

//Back button on mobile for Store Details page
$('.js-store-back-button').on('click', function(){
    window.history.back();
});
